var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.link)?_c('JluButtonLink',_vm._b({staticClass:"c-header-mobile-back-button",attrs:{"variant":"transparent","size":"small"}},'JluButtonLink',_vm.props,false),[_c('JluIcon',{attrs:{"variant":"chevron-left"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }